import { trackEvent } from '@fs/zion-analytics'

export default function handleAnalytics(appConfig) {
  const { analytics } = appConfig
  if (analytics) {
    const trackEventProps = {}
    const link_name = analytics.link_name ? `${analytics.link_name}: ${appConfig.name}` : appConfig.name
    const link_page = analytics.link_page
    const link_app = analytics.link_app || appConfig.product

    // We do not want to override default event props with undefined
    if (link_name) trackEventProps.link_name = link_name
    if (link_page) trackEventProps.link_page = link_page
    if (link_app) trackEventProps.link_app = link_app

    trackEvent(trackEventProps)
  }
}
